import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { company, navLinks } from "../mock";

const FooterBrand = () => (
  <div className="lg:col-span-1">
    <Link to="/" className="flex items-center gap-2.5">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-white font-display font-extrabold text-lg">
        O
      </span>
      <span className="font-display text-xl font-extrabold tracking-tight text-white">
        Ozziee<span className="text-primary">Tech</span>
      </span>
    </Link>
    <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
      Innovative IT solutions for small businesses — SEO, consulting and managed services delivered with care, Australia-wide.
    </p>
  </div>
);

const FooterNav = () => (
  <div>
    <h4 className="font-display font-bold text-white mb-4">Navigate</h4>
    <ul className="space-y-2.5">
      {navLinks.map((l) => (
        <li key={l.path}>
          <Link to={l.path} className="text-sm text-slate-400 hover:text-primary transition-colors">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FOOTER_SERVICES = [
  { path: "/seo", label: "SEO Services" },
  { path: "/seo/auto-engine", label: "SEO Auto Engine (Free Audit)" },
  { path: "/seo/roi-calculator", label: "SEO ROI Calculator" },
  { path: "/consulting", label: "IT Consulting" },
  { path: "/managed-services", label: "Managed IT Services" },
];

const FooterServices = () => (
  <div>
    <h4 className="font-display font-bold text-white mb-4">Our Services</h4>
    <ul className="space-y-2.5">
      {FOOTER_SERVICES.map((l) => (
        <li key={l.path}>
          <Link to={l.path} className="text-sm text-slate-400 hover:text-primary transition-colors">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="font-display font-bold text-white mb-4">Contact</h4>
    <ul className="space-y-3 text-sm">
      <li className="flex items-start gap-3">
        <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
        <span className="text-slate-400">{company.location}</span>
      </li>
      <li className="flex items-center gap-3">
        <Phone className="h-4 w-4 text-primary shrink-0" />
        <a href={`tel:${company.phoneRaw}`} className="text-slate-400 hover:text-primary transition-colors">{company.phone}</a>
      </li>
      <li className="flex items-center gap-3">
        <Mail className="h-4 w-4 text-primary shrink-0" />
        <a href={`mailto:${company.email}`} className="text-slate-400 hover:text-primary transition-colors">{company.email}</a>
      </li>
    </ul>
  </div>
);

const FooterHours = () => (
  <div>
    <h4 className="font-display font-bold text-white mb-4">Business Hours</h4>
    <ul className="space-y-2.5 text-sm text-slate-400">
      <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-primary" /> Mon – Fri</li>
      <li className="pl-7">09:00 am – 05:00 pm</li>
      <li className="pl-7">Sat – Sun: Closed</li>
    </ul>
  </div>
);

const FooterBottom = () => (
  <div className="mt-14 pt-7 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
    <p className="text-xs text-slate-500">{company.copyright}</p>
    <Link to="/privacy-policy" className="text-xs text-slate-500 hover:text-primary transition-colors">
      Privacy Policy
    </Link>
  </div>
);

const Footer = () => (
  <footer className="bg-slate-900 text-slate-300">
    <div className="container-wide py-16">
      <div className="grid gap-12 lg:grid-cols-5">
        <FooterBrand />
        <FooterNav />
        <FooterServices />
        <FooterContact />
        <FooterHours />
      </div>
      <FooterBottom />
    </div>
  </footer>
);

export default Footer;
